import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Icon, Navigation, NavigationItem } from '../ui/index';

interface MainLayoutProps {
  children: ReactNode;
}

type NavSection = 'dashboard' | 'payRuns' | 'events' | 'organisation' | 'settings';

const navItems: Array<{ id: NavSection; label: string; icon: string; path: string }> = [
  { id: 'dashboard', label: 'Dashboard', icon: 'home', path: '/' },
  { id: 'payRuns', label: 'Pay Runs', icon: 'payroll-dollar', path: '/pay-runs' },
  { id: 'events', label: 'Events', icon: 'notifications', path: '/events' },
  { id: 'organisation', label: 'Organisation', icon: 'apps', path: '/organisation' },
  { id: 'settings', label: 'Settings', icon: 'settings', path: '/settings' },
];

export const MainLayout = ({ children }: MainLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const shellRef = useCallback((el: HTMLElement | null) => {
    if (!el) return;
    el.setAttribute('logo', '/humanforce-logo.png');
    el.setAttribute('logo-short', '/humanforce-monogram.png');
  }, []);

  const activeSection = location.pathname.startsWith('/organisation') ? 'organisation' : 'dashboard';

  return (
    // @ts-expect-error native Mango custom element
    <mgo-app-shell label="Pay Roadrunner" ref={shellRef}>
      <Navigation slot="sidebar">
        {navItems.map((item) => (
          <NavigationItem key={item.id} active={activeSection === item.id} onClick={() => navigate(item.path)}>
            <Icon slot="prefix" name={item.icon} />
            {item.label}
          </NavigationItem>
        ))}
      </Navigation>
      <main className="mx-auto w-full max-w-7xl px-4 py-4 lg:px-6 lg:py-6">{children}</main>
    {/* @ts-expect-error native Mango custom element */}
    </mgo-app-shell>
  );
}
